export const CHECKOUT_URL = "https://orthocase-en.impultienda.ar/checkout/";

export const images = {
  product: "https://cdn.magicpatterns.com/uploads/8CGros4ASfqu4hBFjdozqo/ORTHOCASE-EN.png",
  doctor: "https://cdn.magicpatterns.com/uploads/4PW6Mt6HUq4B4tanhjRgB2/DR._NATHAN_BROOKS_-_ORTHO.png",
};

export const valueStack = [
  {
    title: "Ortho Case Command Center™ — 6 Premium Volumes",
    detail: "Case Snapshot · Problem Board · Objective & Priority Matrix · Constraint & Movement Map · Case Sequence Board · Final Command Center",
    value: "$97",
  },
  {
    title: "5 Exclusive Bonuses",
    detail: "15-Minute Case Command Protocol · Complex Case Triage Sheet · Priority Matrix · 30 Case Review Questions · One-Page Case Brief",
    value: "$147",
  },
];

export const offerPerks = [
  { title: "One-time payment", text: "No monthly fees." },
  { title: "Lifetime access", text: "Use the system again and again." },
  { title: "Immediate digital access", text: "Start using the tools immediately." },
  { title: "7-Day Guarantee", text: "Try the entire system risk-free." },
];

export const finalFlow = ["Case", "Problems", "Objectives", "Priorities", "Constraints", "Movement", "Sequence", "Review"];
